__turbopack_context__.v({
  "arrow-button-next": "GallerySlider-module__TDotja__arrow-button-next",
  "arrow-button-prev": "GallerySlider-module__TDotja__arrow-button-prev",
  "disabled": "GallerySlider-module__TDotja__disabled",
  "gallery": "GallerySlider-module__TDotja__gallery",
  "image": "GallerySlider-module__TDotja__image",
  "loader": "GallerySlider-module__TDotja__loader",
  "spin": "GallerySlider-module__TDotja__spin",
  "spinner": "GallerySlider-module__TDotja__spinner",
  "swiper": "GallerySlider-module__TDotja__swiper",
});
